// import Cookies from "js-cookie";
import client from "./axios";

const authUrl = window.__env.AUTH_URL;

export type Credentials = {
  username: string;
  password: string;
}

export const Authentication = {
  // login: (credentials: Credentials) => {
  //   const urlFormEncodedBody = new URLSearchParams();
  //   Object.entries(credentials).forEach(([key, value]) => urlFormEncodedBody.set(key, value));
  //   urlFormEncodedBody.set("client_secret", window.__env.AUTH_CLIENT_SECRET);
  //   urlFormEncodedBody.set("client_id", window.__env.AUTH_CLIENT_ID);
  //   urlFormEncodedBody.set("grant_type", "password");
  //   urlFormEncodedBody.set("scope", "openid");

  //   return client.post(`${authUrl}/token`, urlFormEncodedBody);
  // },
  // logout: () => {
  //   const urlFormEncodedBody = new URLSearchParams();
  //   urlFormEncodedBody.set("client_secret", window.__env.AUTH_CLIENT_SECRET);
  //   urlFormEncodedBody.set("client_id", window.__env.AUTH_CLIENT_ID);
  //   urlFormEncodedBody.set("refresh_token", Cookies.get(window.__env.AUTH_REFRESH_TOKEN_NAME) as string);
  //   return client.post(`${authUrl}/logout`, urlFormEncodedBody);
  // },
  // refresh: (token) => client.post(`${authUrl}/refreshToken`, { refresh_token: token }),
  userInfo: () => client.get(`${authUrl}/userinfo`),
}